import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { customerApi } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [customer, setCustomer] = useState(undefined); // undefined = checking, null = logged out
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem('tiffin_customer_token');
    if (!token) {
      setCustomer(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await customerApi.get('/auth/customer/me');
      setCustomer(data.customer);
    } catch {
      localStorage.removeItem('tiffin_customer_token');
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await customerApi.post('/auth/customer/login', { email, password });
    localStorage.setItem('tiffin_customer_token', data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const register = async (payload) => {
    const { data } = await customerApi.post('/auth/customer/register', payload);
    localStorage.setItem('tiffin_customer_token', data.token);
    setCustomer(data.customer);
    return data;
  };

  const logout = () => {
    const deviceToken = localStorage.getItem('tiffin_push_token');
    if (deviceToken) {
      customerApi.delete('/notifications/register-device', { data: { token: deviceToken } }).catch(() => {});
      localStorage.removeItem('tiffin_push_token');
    }
    localStorage.removeItem('tiffin_customer_token');
    setCustomer(null);
  };

  const refresh = () => loadMe();

  return (
    <AuthContext.Provider value={{ customer, loading, login, register, logout, refresh, setCustomer }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
